export default {
    // === TOWNSFOLK ===
    washerwoman: {
        name: 'Wäscherin',
        description: 'Du erfährst, dass einer von zwei Spielern eine bestimmte gute Rolle hat.',
        ability: 'In der ersten Nacht erfährst du zwei Spieler, von denen einer eine bestimmte gute Rolle hat.',
    },
    librarian: {
        name: 'Bibliothekar',
        description: 'Du erfährst, dass einer von zwei Spielern ein Außenseiter ist.',
        ability: 'In der ersten Nacht erfährst du zwei Spieler, von denen einer ein Außenseiter ist (oder dass keiner im Spiel ist).',
    },
    investigator: {
        name: 'Ermittler',
        description: 'Du erfährst, dass einer von zwei Spielern ein Handlanger ist.',
        ability: 'In der ersten Nacht erfährst du zwei Spieler, von denen einer ein Handlanger ist.',
    },
    chef: {
        name: 'Koch',
        description: 'Du erfährst, wie viele Paare benachbarter böser Spieler es gibt.',
        ability: 'In der ersten Nacht erfährst du, wie viele Paare benachbarter böser Spieler es gibt.',
    },
    empath: {
        name: 'Empath',
        description: 'Du erfährst, wie viele deiner lebenden Nachbarn böse sind.',
        ability: 'Jede Nacht erfährst du, wie viele deiner lebenden Nachbarn böse sind.',
    },
    fortuneteller: {
        name: 'Wahrsagerin',
        description: 'Du kannst zwei Spieler wählen und erfährst, ob einer davon der Dämon ist.',
        ability: 'Jede Nacht wählst du zwei Spieler: Du erfährst, ob einer von ihnen der Dämon ist. Es gibt einen guten Spieler, der immer als Dämon registriert.',
    },
    undertaker: {
        name: 'Bestatter',
        description: 'Du erfährst die Rolle des am Tag hingerichteten Spielers.',
        ability: 'Jede Nacht erfährst du die Rolle des am Tag hingerichteten Spielers.',
    },
    monk: {
        name: 'Mönch',
        description: 'Du kannst einen Spieler vor dem Dämon schützen.',
        ability: 'Jede Nacht wählst du einen anderen Spieler als dich selbst: Er kann in dieser Nacht nicht vom Dämon getötet werden.',
    },
    ravenkeeper: {
        name: 'Rabenwächter',
        description: 'Wenn du stirbst, erfährst du die Rolle eines Spielers.',
        ability: 'Wenn du in der Nacht stirbst, wirst du geweckt und darfst einen Spieler wählen: Du erfährst seine Rolle.',
    },
    virgin: {
        name: 'Jungfrau',
        description: 'Das erste Mal, wenn dich jemand nominiert, wird er hingerichtet (falls Dorfbewohner).',
        ability: 'Das erste Mal, wenn dich ein Dorfbewohner nominiert, wird er sofort hingerichtet.',
    },
    slayer: {
        name: 'Dämonenjäger',
        description: 'Du kannst einmal im Spiel öffentlich einen Spieler wählen - er stirbt, wenn er der Dämon ist.',
        ability: 'Einmal im Spiel kannst du am Tag öffentlich einen Spieler wählen: Wenn er der Dämon ist, stirbt er.',
    },
    soldier: {
        name: 'Soldat',
        description: 'Du bist immun gegen die Fähigkeit des Dämons.',
        ability: 'Du bist immun gegen die Fähigkeit des Dämons.',
    },
    mayor: {
        name: 'Bürgermeister',
        description: 'Wenn nur 3 Spieler leben und niemand stirbt, gewinnt dein Team.',
        ability: 'Wenn nur 3 Spieler leben und keine Hinrichtungen stattfinden, gewinnt dein Team.',
    },
    // === OUTSIDER ===
    butler: {
        name: 'Butler',
        description: 'Du darfst nur stimmen, wenn dein Herr auch stimmt.',
        ability: 'Jede Nacht wählst du einen Spieler (nicht dich selbst): Morgen darfst du nur stimmen, wenn er auch stimmt.',
    },
    drunk: {
        name: 'Betrunkener',
        description: 'Du weißt nicht, dass du der Betrunkene bist. Du denkst, du bist eine gute Rolle, aber deine Fähigkeit funktioniert nicht.',
        ability: 'Du weißt nicht, dass du der Betrunkene bist. Du denkst, du hast eine Dorfbewohner-Fähigkeit, aber sie funktioniert nicht.',
    },
    recluse: {
        name: 'Einsiedler',
        description: 'Du könntest als böse oder als Handlanger/Dämon registrieren, auch wenn du tot bist.',
        ability: 'Du könntest als böse, als Handlanger oder als Dämon registrieren, auch wenn du tot bist.',
    },
    saint: {
        name: 'Heiliger',
        description: 'Wenn du hingerichtet wirst, verliert dein Team.',
        ability: 'Wenn du am Tag hingerichtet wirst, endet das Spiel und dein Team verliert.',
    },
    // === MINIONS ===
    poisoner: {
        name: 'Giftmischer',
        description: 'Du kannst jede Nacht einen Spieler vergiften.',
        ability: 'Jede Nacht wählst du einen Spieler: Er ist bis zum nächsten Abend vergiftet und seine Fähigkeit funktioniert nicht.',
    },
    spy: {
        name: 'Spion',
        description: 'Du siehst die Grimoire und könntest als gut oder als Dorfbewohner/Außenseiter registrieren.',
        ability: 'Jede Nacht siehst du das Grimoire. Du könntest als gut oder als Dorfbewohner/Außenseiter registrieren.',
    },
    scarletwoman: {
        name: 'Scharlachrote Frau',
        description: 'Wenn mehr als 5 Spieler leben und der Dämon stirbt, wirst du zum Dämon.',
        ability: 'Wenn es 5 oder mehr Spieler gibt und der Dämon stirbt, wirst du zum Dämon.',
    },
    baron: {
        name: 'Baron',
        description: 'Es gibt zusätzliche Außenseiter im Spiel.',
        ability: 'Es gibt 2 zusätzliche Außenseiter im Spiel.',
    },
    // === DEMON ===
    imp: {
        name: 'Imp',
        description: 'Du tötest jede Nacht einen Spieler. Wenn du dich selbst tötest, stirbt ein Handlanger und wird zum Imp.',
        ability: 'Jede Nacht wählst du einen Spieler: Er stirbt. Wenn du dich selbst tötest, wählt ein lebender Handlanger, der zum Imp wird.',
    },
};
